import { render } from "./RankingItem.vue?vue&type=template&id=37a4ea46"
import script from "./RankingItem.vue?vue&type=script&lang=js"
export * from "./RankingItem.vue?vue&type=script&lang=js"

import "./RankingItem.vue?vue&type=style&index=0&id=37a4ea46&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__